import qs from "qs";
import {apiVoissa} from "../../libs/api";


export const fetchVideoCategories = (query = {}, config = {}) => apiVoissa.get(`/facettes/suggestion-video?${qs.stringify(query)}`, config);
export const fetchPhotoCategories = (query = {}, config = {}) => apiVoissa.get(`/facettes/suggestion-photo?${qs.stringify(query)}`, config);
export const fetchPublicationCategories = (kind='photo', query = {}, config = {}) => apiVoissa.get(`/facettes/suggestion-${kind}?${qs.stringify(query)}`, config);
export const fetchCategoriesRootMedia = (config = {}) => apiVoissa.get(`/categories/childrens-root?slug!=media,voissa&sort=title`, config);

export const fetchCategory = (categoryId, query = {}, config = {}) => apiVoissa.get(`/categories/${categoryId}?${qs.stringify(query)}`, config);

export const fetchCategoryRoot = (categoryIdSlug,query = {}, config = {}) => apiVoissa.get(`/categories/${categoryIdSlug}?${qs.stringify(query)}`, config);

export const fetchCategoriesForMenu = (categoryId,query = {}, config = {}) => apiVoissa.get(`/categories/find-menu/${categoryId}?${qs.stringify(query)}`, config);
export const fetchCategoriesRootNotIa = (config = {}) => apiVoissa.get(`/categories/?slug!=genre,temperature,media,voissa&sort=title`, config);


export const CATEGORIES_VIDEOS_KEY = `categories-videos`;
export const CATEGORIES_PHOTOS_KEY = `categories-photos`;
export const CATEGORIES_PUBLICATIONS_KEY = `categories-publications`;
export const CATEGORIES_ROOT_MEDIAS_KEY = `categories-root-medias`;

export const CATEGORY_KEY = `category`;
export const CATEGORIES_MODE_VIDEO_KEY = `categories-mode-video`;

export const CATEGORIES_ROOT_KEY = `categories-root`;
export const CATEGORIES_MENU_KEY = `categories-menu`;
export const CATEGORIES_ROOT_NO_IA_KEY = `categories-root-no-ia`;